"use client";

import { c as _c } from "react/compiler-runtime";
import { resolveIpfsUrlSync } from "@/components/ipfs/IPFSContext";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { useCompactMode } from "@/contexts/CompactModeContext";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import Image from "next/image";
import Link from "next/link";
import React, { useState } from "react";
interface WaveDropAuthorPfpProps {
  readonly drop: ApiDrop;
}
type PfpLoadMode = "optimized" | "unoptimized" | "placeholder";
type PfpLoadState = {
  src: string | null;
  mode: PfpLoadMode;
};
const WaveDropAuthorPfp: React.FC<WaveDropAuthorPfpProps> = t0 => {
  const $ = _c(12);
  const {
    drop
  } = t0;
  const compact = useCompactMode();
  const resolvedPfp = drop.author.pfp ? resolveIpfsUrlSync(drop.author.pfp) : null;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      src: null,
      mode: "optimized"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [loadState, setLoadState] = useState(t1);
  const loadMode = loadState.src === resolvedPfp ? loadState.mode : "optimized";
  const setLoadMode = mode => {
    setLoadState({
      src: resolvedPfp,
      mode
    });
  };
  const authorHandle = drop.author.handle;
  const profileHref = authorHandle ? `/${authorHandle}` : null;
  const tooltipUser = authorHandle ?? drop.author.id;
  const sizeClasses = compact ? "tw-h-8 tw-w-8" : "tw-h-10 tw-w-10";
  const containerClasses = `tw-relative tw-flex-shrink-0 ${sizeClasses} tw-rounded-lg tw-bg-iron-900 tw-overflow-hidden`;
  const handleImageError = () => {
    if (loadMode === "optimized") {
      setLoadMode("unoptimized");
      return;
    }
    setLoadMode("placeholder");
  };
  const avatarContent = resolvedPfp === null || loadMode === "placeholder" ? <div className="tw-h-full tw-w-full tw-rounded-lg tw-bg-iron-900 tw-ring-1 tw-ring-inset tw-ring-white/10" /> : <Image key={`${resolvedPfp}-${loadMode}`} src={getScaledImageUri(resolvedPfp, ImageScale.W_AUTO_H_50)} alt={authorHandle ? `${authorHandle}'s profile picture` : "Profile picture"} fill={true} sizes={compact ? "32px" : "40px"} unoptimized={loadMode === "unoptimized"} onError={handleImageError} className="tw-rounded-lg tw-bg-transparent tw-object-contain" />;
  const handleClick = _temp;
  if (!profileHref) {
    let t2;
    if ($[1] !== avatarContent || $[2] !== containerClasses) {
      t2 = <div className={containerClasses}>{avatarContent}</div>;
      $[1] = avatarContent;
      $[2] = containerClasses;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  const t2 = `View ${tooltipUser}'s profile`;
  const t3 = `${containerClasses} tw-block`;
  let t4;
  if ($[4] !== avatarContent || $[5] !== profileHref || $[6] !== t2 || $[7] !== t3) {
    t4 = <Link href={profileHref} prefetch={false} aria-label={t2} onClick={handleClick} className={t3}>{avatarContent}</Link>;
    $[4] = avatarContent;
    $[5] = profileHref;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4 || $[10] !== tooltipUser) {
    t5 = <UserProfileTooltipWrapper user={tooltipUser}>{t4}</UserProfileTooltipWrapper>;
    $[9] = t4;
    $[10] = tooltipUser;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default WaveDropAuthorPfp;
function _temp(event) {
  event.stopPropagation();
}